import axios from 'axios';
import { supabase } from '../supabaseClient';
async function getAllCp(from, to, search, selectedStatusArray, selectedTypeArray, drpDownSelectedVal) {
  console.log(from, to, search, selectedStatusArray, selectedTypeArray, drpDownSelectedVal)

  if (search === undefined) {
    search = null;
  }
  const filters = {
    "Name Ascending": {
      key: 'name',
      isAscending: true
    },
    "Name Descending": {
      key: 'name',
      isAscending: false
    },
    "Oldest First": {
      key: 'last_updated_at',
      isAscending: true
    },
    "Latest First": {
      key: 'last_updated_at',
      isAscending: false
    }
  }
  var query;
  query = supabase
    .from('CpContactPerson')
    .select('*, cpId(*,KycDocuments!left(*),recommendedBySalesId(*))', { count: 'exact' })
    .order(filters[drpDownSelectedVal].key, { ascending: filters[drpDownSelectedVal].isAscending })
    .range(from, to);

  if (selectedStatusArray.length !== 0) {
    console.log(selectedStatusArray);
    query = query.in('cpId.approvalStatus', selectedStatusArray);
  }
  if (selectedTypeArray.length !== 0) {
    console.log(selectedTypeArray);
    query = query.in('cpId.cpType', selectedTypeArray);
  }
  if (search !== null) {
    search = search.replace(/\s\s+/g, ' ')
    query = query.ilike('name', `%${search}%`);
  }

  //Main query
  // const { data, error, count } = await supabase
  //   .from('CpContactPerson')
  //   .select('*, cpId(*,KycDocuments!left(*),recommendedBySalesId(*))', { count: 'exact' })
  //   .ilike('name', `%${search}%`)

  const { data, count, error } = await query
  console.log(data)
  if (data) return { data, count };
  else throw error;
}
// !!Change
// startDate / endDate filter on created_at. CP.created_at is stored as epoch
// milliseconds (a bigint, not a timestamp), so these are numbers — the caller
// passes the start of the first day and the end of the last day.
async function getAllCpFromCpTable(from, to, search, selectedStatusArray, selectedTypeArray, drpDownSelectedVal, startDate = null, endDate = null) {
  console.log(from, to, search, selectedStatusArray, selectedTypeArray, drpDownSelectedVal, startDate, endDate)

  if (search === undefined) {
    search = null;
  }
  const filters = {
    "Name Ascending": {
      key: 'billingName',
      isAscending: true
    },
    "Name Descending": {
      key: 'billingName',
      isAscending: false
    },
    "Oldest First": {
      key: 'last_updated_at',
      isAscending: true
    },
    "Latest First": {
      key: 'last_updated_at',
      isAscending: false
    }
  }
  var query;
  query = supabase
    .from('CP')
    // DeletedCpFos carries the archived contact details for suspended CPs, whose
    // CpContactPerson row has been hard-deleted -- contactEmail/contactNumber are
    // selected alongside contactName so the grid and the mobile detail screen can
    // show all three instead of blanks.
    .select('*,recommendedBySalesId(name),cpSourceId(name),CpContactPerson!left(name,contactNumber,email),DeletedCpFos!left(contactName,contactEmail,contactNumber))', { count: 'exact' })
    .order(filters[drpDownSelectedVal].key, { ascending: filters[drpDownSelectedVal].isAscending })
    .range(from, to);

  if (selectedStatusArray.length !== 0) {
    console.log(selectedStatusArray);
    query = query.in('approvalStatus', selectedStatusArray);
  }
  if (selectedTypeArray.length !== 0) {
    console.log(selectedTypeArray);
    query = query.in('cpType', selectedTypeArray);
  }
  if (startDate !== null && startDate !== undefined) {
    query = query.gte('created_at', startDate);
  }
  if (endDate !== null && endDate !== undefined) {
    query = query.lte('created_at', endDate);
  }
  if (search !== null) {
    var alphabets = new RegExp('^[a-zA-Z ]*$');
    if (alphabets.test(search)) {
      search = search.replace(/\s\s+/g, ' ')
      query = query.ilike('billingName', `%${search}%`);
    }
    else {
      const searching = search.replace(/cpid/gi, '');

      console.log('search on displayId', searching);
      query = query.ilike('cpDisplayId', `%${searching}%`);
    }
  }

  //Main query
  // const { data, error, count } = await supabase
  //   .from('CpContactPerson')
  //   .select('*, cpId(*,KycDocuments!left(*),recommendedBySalesId(*))', { count: 'exact' })
  //   .ilike('name', `%${search}%`)

  const { data, count, error } = await query
  console.log(data)
  if (data) return { data, count };
  else throw error;
}


async function CheckCpIdExists(cpId) {
  const { data, error } = await supabase
    .from('Leads').select("*").eq('cpId', cpId);
  if (data) return data;
  else throw error;
}

async function DeleteAuthFromServer(email) {
  // let query = supabase.rpc('getuniqueunittypesforcolorselection', { pid: eventId })
  // const { data, error } = await query;
  // if (data) return { data };
  // else throw error;
}

async function CheckFosIdExists(fosId) {
  const { data, error } = await supabase
    .from('Leads').select("*").eq('fosId', fosId);
  if (data) return data;
  else throw error;
}

async function deleteAuthByEmail(email) {
  let query = supabase.rpc('deleteauthuser', { authemail: email })
  const { data, error } = await query;
  if (data) return { data };
  else throw error;
}


// !!FOS
// fosStatusArray / startDate / endDate are additive — the existing search and
// sort behaviour below is untouched. Status here means the only status a FOS
// record has: whether its login is disabled.
async function getAllFOSFromTable(from, to, search, selectedStatusArray, selectedTypeArray, drpDownSelectedVal, startDate = null, endDate = null, fosStatusArray = []) {
  console.log(from, to, search, selectedStatusArray, selectedTypeArray, drpDownSelectedVal, startDate, endDate, fosStatusArray)

  if (search === undefined) {
    search = null;
  }
  const filters = {
    "Name Ascending": {
      key: 'name',
      isAscending: true
    },
    "Name Descending": {
      key: 'name',
      isAscending: false
    },
    "Oldest First": {
      key: 'last_updated_at',
      isAscending: true
    },
    "Latest First": {
      key: 'last_updated_at',
      isAscending: false
    }
  }
  var query;
  query = supabase
    .from('FOS')
    .select('*,cpId(*))', { count: 'exact' })
    .order(filters[drpDownSelectedVal].key, { ascending: filters[drpDownSelectedVal].isAscending })
    .range(from, to);

  // if (selectedStatusArray.length !== 0) {
  //   console.log(selectedStatusArray);
  //   query = query.in('approvalStatus', selectedStatusArray);
  // }
  // if (selectedTypeArray.length !== 0) {
  //   console.log(selectedTypeArray);
  //   query = query.in('cpType', selectedTypeArray);
  // }

  // Selecting both (or neither) means no constraint. Active records may have
  // isDisabled null rather than false, so match both.
  if (fosStatusArray && fosStatusArray.length === 1) {
    if (fosStatusArray[0] === 'Disabled') {
      query = query.eq('isDisabled', true);
    } else if (fosStatusArray[0] === 'Active') {
      query = query.or('isDisabled.is.null,isDisabled.eq.false');
    }
  }
  // Filters on created_at only, exactly like getAllCpFromCpTable — a record
  // updated inside the range but created outside it is NOT returned.
  // FOS.created_at is a numeric column holding epoch milliseconds
  // (e.g. 1680666993080), not a timestamp, so the bounds pass through as raw
  // numbers. Converting to ISO would compare a string against a numeric column
  // and match nothing. Callers supply whole-day bounds, so a single-day range
  // covers 00:00:00.000 to 23:59:59.999 of that day.
  if (startDate !== null && startDate !== undefined) {
    query = query.gte('created_at', startDate);
  }
  if (endDate !== null && endDate !== undefined) {
    query = query.lte('created_at', endDate);
  }

  if (search !== null) {
    var alphabets = new RegExp('^[a-zA-Z ]*$');
    if (alphabets.test(search)) {
      search = search.replace(/\s\s+/g, ' ')
      query = query.ilike('name', `%${search}%`);
    }
    else {
      const searching = search.replace(/fosid/gi, '');

      console.log('search on displayId', searching);
      query = query.ilike('fosDisplayId', `%${searching}%`);
    }
  }

  const { data, count, error } = await query
  console.log(data)
  if (data) return { data, count };
  else throw error;
}
async function updateStatus(cpId, status, rejectionReason) {
  const updatePayload = { approvalStatus: status, rejectionReason: rejectionReason, last_updated_at: Date.now() };
  if (status === 'approved') {
    updatePayload.approved_at = Date.now();
  }
  const { data, error } = await supabase
    .from('CP').update(updatePayload).eq('cpId', cpId);
  if (data) return data;
  else throw error;
}
// note is optional: only the suspend flow captures one. The approve/reject
// callers pass three arguments and leave CpLogs.note null.
async function insertCpLogs(cpId, status, salesId, note = null) {
  const { data, error } = await supabase
    .from('CpLogs')
    .insert([{ cpId: cpId, cpStatus: status, userId: salesId, note: note }])
    // Without .select() supabase-js resolves data to null on an insert, so the
    // old `if (data) return data; else throw error` threw on every successful
    // write (with error also null). The row went in, but every caller's .catch
    // fired -- which would have looked like the note failing to save.
    .select();
  if (error) throw error;
  return data;
}

async function getCpById(cpId) {
  const { data, error } = await supabase
    .from('CP')
    .select('*')
    .eq('cpId', cpId)
    .maybeSingle();
  if (error) throw error;
  return data;
}

// Admin-triggered unlock for the CP Profile Update flow -- lets an *approved*
// CP edit their profile again without going through Reject. Editability is
// driven by CP.approvalStatus itself ("Profile Update" is a new value
// alongside approved/rejected/resubmitted/disable/pending) rather than a
// separate boolean flag -- the CP's own resubmit write already flips this
// column back to "resubmitted" on submit, so no extra field needs
// re-locking. The current status IS the double-unlock guard: this only
// proceeds from "approved", so a CP already mid-cycle can't be re-triggered.
// One CpLogs row per cycle, logged before the status flip so a failed
// update never leaves an unlocked CP with no audit row at all.
async function unlockCpProfileForEdit(cpId, adminUserId) {
  const cp = await getCpById(cpId);
  if (!cp) throw new Error('CP not found');
  if (cp.approvalStatus !== 'approved') {
    return {
      success: false,
      blocked: true,
      message: `Cannot unlock — this CP is currently "${cp.approvalStatus}", not approved.`,
    };
  }

  // Pre-edit CP row is stashed as JSON in this same note column -- no
  // separate snapshot column needed. CP-APP-FRONTEND overwrites this same
  // row's note with a plain readable sentence once the CP submits, so a
  // row whose note doesn't parse as { old: ... } means that cycle already
  // closed (see Profile.jsx's close-out logic).
  const { error: logError } = await supabase
    .from('CpLogs')
    .insert([{ cpId: cpId, cpStatus: 'Profile Update', userId: adminUserId, note: JSON.stringify({ old: cp }) }]);
  if (logError) throw logError;

  const { error: unlockError } = await supabase
    .from('CP')
    .update({ approvalStatus: 'Profile Update' })
    .eq('cpId', cpId);
  if (unlockError) throw unlockError;

  return { success: true };
}

async function insertFosLogs(fosId, status, cpContactPersonId) {
  const { data, error } = await supabase
    .from('FosLogs')
    .insert([{ fosId: fosId, fosStatus: status, cpContactPersonId: cpContactPersonId }])
  if (data) return data;
  else throw error;
}

async function getAllCpForLaunch(search) {
  let query = supabase.from('CP').select('*,CpContactPerson!left(*)', { count: 'exact' }).eq('approvalStatus', 'approved')
  if (search !== null || search !== '' || search !== undefined) {
    query = query.ilike("billingName", `%${search}%`);
  }
  const { data, error, count } = await query;
  if (data) return { data, count };
  else throw error;
}

async function updateCPBenefitPlan(benefitPlanId, cpId) {
  const { data, error } = await supabase
    .from('CP').update({ benefitPlanId: benefitPlanId }).eq('cpId', cpId);
  if (data) return data;
  else throw error;
}
async function getAllFOSUnderCP(cpId) {
  let query = supabase.from('FOS').select('*', { count: 'exact' }).eq('cpId', cpId)
  const { data, error, count } = await query;
  if (data) return { data, count };
  else throw error;
}


function CreateNewBroker(cpId) {
  return new Promise((resolve, reject) => {
    axios.post(process.env.REACT_APP_PAYMENT_LINK_URL + 'payments/createNewBroker', { cpId: cpId }).then((resp) => {
      resolve(resp);
    }).catch((err) => {
      reject(err);
    });
  })
}

async function getKYCDocuments(cpId) {
  const { data, error } = await supabase
    .from('KycDocuments').select("*").eq('cpId', cpId);
  if (data) return data;
  else throw error;
}
async function getFOSKYCDocuments(fosId) {
  const { data, error } = await supabase
    .from('KycDocuments').select("*").eq('fosId', fosId);
  if (data) return data;
  else throw error;
}

async function getDeletedCpData(cpId) {
  const { data, error } = await supabase
    .from('DeletedCpFos')
    .select("*")
    .eq('cpId', cpId)
    .order('deleted_at', { ascending: false })
    .limit(1)
    .maybeSingle();
  if (error) throw error;
  return data;
}

async function getDeletedFosData(fosId) {
  const { data, error } = await supabase
    .from('DeletedCpFos')
    .select("*")
    .eq('fosId', fosId)
    .order('deleted_at', { ascending: false })
    .limit(1)
    .maybeSingle();
  if (error) throw error;
  return data;
}

// Site visits and allotments hang off a CP's LEADS, not off the CP directly --
// same join path as CheckCpIdExists above. AllotmentPayment has no cpId column
// at all, and SiteVisits' cpId column is not reliably populated (a sandbox CP
// with one lead showed 1 site visit through the lead join and 0 through
// SiteVisits.cpId), so both counts go through Leads to stay consistent.
//
// The join is embedded rather than fetching leadIds first and passing them to
// .in(): one round trip instead of two, and no lead-count-proportional query
// string to outgrow the URL limit. leadId!inner keeps only rows whose lead
// belongs to this CP. Verified to return identical counts to the two-step form.
// Both counts are informational -- they are displayed to the admin and never
// block a suspend -- so a CP with no leads correctly reports 0.
async function getCpSiteVisitCount(cpId) {
  const { count, error } = await supabase
    .from('SiteVisits')
    .select('*, leadId!inner(cpId)', { count: 'exact', head: true })
    .eq('leadId.cpId', cpId);
  if (error) throw error;
  return count || 0;
}

async function getCpAllotmentCount(cpId) {
  const { count, error } = await supabase
    .from('AllotmentPayment')
    .select('*, leadId!inner(cpId)', { count: 'exact', head: true })
    .eq('leadId.cpId', cpId);
  if (error) throw error;
  return count || 0;
}

// CpPayments.Status is not a closed set: fvSchedular assigns it straight from
// the FarVision API's DocumentStatus field (SALES-APP-BACKEND-NODE-API/
// cppayments/fvSchedular.js:87-90), so new values can appear without any change
// here. The rule is therefore an allowlist -- an unrecognised status blocks the
// suspend rather than silently permitting it.
//
// Values the backend actually writes:
//   allowed  Full Payment Done / Partial Payment Done   fvSchedular.js:833
//            Payment In Process                         fvSchedular.js:487
//            Payment Done                               legacy, no current writer;
//                                                       CP Payout's own
//                                                       isPaymentDoneStatus() already
//                                                       counts it as settled, so this
//                                                       agrees with the payout module
//   blocks   Pending For Invoice   cpSchedular.js:1293, cpPaymentManualService.js:455
//            Pending / InReview    fvInvertSubscription.js:388, :200
//            APPROVED / REJECTED   fvSchedular.js:102, :89 -- invoice approved is not
//                                  money paid, so it still blocks
//
// Compared lowercased and trimmed because the live data carries casing variants
// ('Pending for invoice' exists alongside 'Pending For Invoice'), the same
// reason CP Payout's isPaymentDoneStatus() normalises before matching.
const SUSPEND_ALLOWED_PAYMENT_STATUSES = [
  'full payment done',
  'partial payment done',
  'payment in process',
  'payment done',
];

// Replaces the old boolean checkCpPendingInvoice(). Renamed on purpose: the
// contract inverted -- canSuspend === true now means "OK to suspend", where the
// old function returned true to mean BLOCKED -- so any call site that was missed
// fails loudly instead of silently flipping the gate.
//
// Returns { canSuspend, total, summary, blocking }:
//   summary  one entry per distinct status, [{ status, count, blocks }], busiest
//            first -- this is what the confirmation modal renders
//   blocking just the entries that block, for the inline "why" message
// A CP with no CpPayments rows has nothing unsettled, so canSuspend is true.
async function getCpPaymentSuspendCheck(cpId) {
  const { data, error } = await supabase
    .from('CpPayments')
    .select('Status')
    .eq('CpId', cpId)
    // isDeleted is nullable (default false). A NULL row must still be evaluated:
    // skipping it could drop a blocking status and wrongly allow the suspend.
    .or('isDeleted.is.null,isDeleted.eq.false');
  if (error) throw error;

  const rows = data || [];
  // Tally on the raw label so the modal shows the same wording the admin sees in
  // CP Payout, while the allow/block decision uses the normalised form.
  const tally = new Map();
  rows.forEach((row) => {
    const label = row.Status === null || row.Status === '' ? 'No Status' : String(row.Status);
    const entry = tally.get(label) || {
      status: label,
      count: 0,
      blocks: !SUSPEND_ALLOWED_PAYMENT_STATUSES.includes(label.toLowerCase().trim()),
    };
    entry.count += 1;
    tally.set(label, entry);
  });

  const summary = [...tally.values()].sort((a, b) => b.count - a.count);
  return {
    canSuspend: summary.every((entry) => !entry.blocks),
    total: rows.length,
    summary,
    blocking: summary.filter((entry) => entry.blocks),
  };
}

function updateFosCP(id, is_cpid) {
  return new Promise((resolve, reject) => {
    axios.post(process.env.REACT_APP_FOSCP_DELETION_BASE_URL + '/updateFosCP', { id, is_cpid }, {
      headers: { Authorization: `Bearer ${process.env.REACT_APP_FOSCP_DELETION_TOKEN}` }
    }).then((resp) => {
      resolve(resp);
    }).catch((err) => {
      reject(err);
    });
  })
}

function suspendCp(cpId) {
  return new Promise((resolve, reject) => {
    axios.post(process.env.REACT_APP_PAYMENT_LINK_URL + 'api/cp-deletion/suspend', { cpId }).then((resp) => {
      resolve(resp);
    }).catch((err) => {
      reject(err);
    });
  })
}

function suspendFos(fosId) {
  return new Promise((resolve, reject) => {
    axios.post(process.env.REACT_APP_PAYMENT_LINK_URL + 'api/cp-deletion/suspend-fos', { fosId }).then((resp) => {
      resolve(resp);
    }).catch((err) => {
      reject(err);
    });
  })
}

export {
  getAllCp, updateStatus, insertCpLogs, getAllCpForLaunch,
  updateCPBenefitPlan, getAllFOSUnderCP, getAllCpFromCpTable, getAllFOSFromTable, CheckCpIdExists, CheckFosIdExists, deleteAuthByEmail, CreateNewBroker,
  getKYCDocuments, getFOSKYCDocuments, getCpPaymentSuspendCheck, updateFosCP, suspendCp, getDeletedCpData, suspendFos, getDeletedFosData, insertFosLogs,
  getCpSiteVisitCount, getCpAllotmentCount, getCpById, unlockCpProfileForEdit
}